import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import { FormattedMessage } from 'react-intl'
import FormatPercent from '../utils/Formatters/FormatPercent'

interface Props {
  marginValue: number
  margin?: number
  supplier?: string
  colour?: 'highlight-primary-dark' | 'critical'
  /**
   * Controls whether the messaging to state the credit is an estimate or exact value.
   */
  type:
    | 'exact'
    | 'estimate'
    | 'ao_estimate'
    | 'ao_exact'
    | 'bedbank_exact'
    | 'bedbank_exact_accom'
    | 'bedbank_estimate'
    | 'property_estimate'
    | 'property_estimate_accom'
    | 'le_estimate'
    | 'package_upgrade_comparison_positive'
  currency?: string
}

function PriceRowMarginText(props: Props) {
  const {
    marginValue,
    margin,
    supplier,
    colour = 'highlight-primary-dark',
    type,
  } = props

  return <Caption
    variant="medium"
    weight="bold"
    colour={colour}
  >
    {type === 'estimate' && <FormattedMessage
      id="cqE79rSb1cYkZROAhSTF"
      defaultMessage="Margin value up to: {amount}"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" /> }}
    />}
    {type === 'exact' && <FormattedMessage
      id="pGcIK3vJRpKy3UtEIYUk"
      defaultMessage="Margin value: {amount}"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" /> }}
    />}

    {type === 'ao_estimate' && <FormattedMessage
      id="GQdlBLzoSeHfQZGXX5Ye"
      defaultMessage="Margin value up to: {amount} {percent} (local currency)"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" />, percent: margin ? `(${margin}%)` : '' }}
    />}
    {type === 'ao_exact' && <FormattedMessage
      id="QCthlmA79y9Z7_3tUIwB"
      defaultMessage="Margin value: {amount} {percent} (local currency)"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" />, percent: margin ? `(${margin}%)` : '' }}
    />}

    {type === 'bedbank_exact' && <FormattedMessage
      id="NBcOw1I7mKQzdPhjBcOS"
      defaultMessage="Margin: {amount} ({percent}%) | ({supplier})"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" />, percent: margin, supplier }}
    />}
    {type === 'bedbank_exact_accom' && <FormattedMessage
      id="MPet1HQyhUeClpmtn9Vh"
      defaultMessage="Margin: {amount} ({percent}%) | ({supplier}) | Accommodation Only"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" />, percent: margin, supplier }}
    />}
    {type === 'bedbank_estimate' && <FormattedMessage
      id="X3xfS7j5nkJxX6ouFHrK"
      defaultMessage="Margin value up to: {amount} ({percent}%) | ({supplier})"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" />, percent: margin, supplier }}
    />}
    {/* TODO(HP-1367): Add exact variations when SPP margin details are well-defined. */}
    {type === 'property_estimate' && <FormattedMessage
      id="2e0qCrqLQfB7kfsKjANA"
      defaultMessage="Margin value up to: {amount} ({percent}%){supplier}"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" />, percent: margin, supplier: supplier ? ` | (${supplier})` : '' }}
    />}
    {type === 'property_estimate_accom' && <FormattedMessage
      id="BKeUYqdPWwKHy3cIl7lD"
      defaultMessage="Margin value up to: {amount} ({percent}%){supplier} | Accommodation Only"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" />, percent: margin, supplier: supplier ? ` | (${supplier})` : '' }}
    />}
    {type === 'le_estimate' && <FormattedMessage
      id="HGnwbSTRVBC_rzacpVae"
      defaultMessage="Estimated margin: {percent}"
      
      values={{ percent: <FormatPercent value={margin!} /> }}
    />}
    {type === 'package_upgrade_comparison_positive' && <FormattedMessage
      id="28aZniqOC70FyG5xO_QG"
      defaultMessage="Earn +{amount} more margin with this room upgrade!"
      
      values={{ amount: <FormatCurrency value={marginValue} format="roundedDollar" currency="AUD" /> }}
    />}
  </Caption>
}

export default PriceRowMarginText
